import React, { useContext } from "react";

import { Routes, Route, Outlet } from "react-router-dom";

import "./index.css";
import "./chart.css";
import "./step.css";

import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";
import ScrollToTop from "./pages/ScrollToTop";

import LockScreen from "./pages/LockScreen";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import Setting from "./layouts/Setting";
import { ThemeContext } from "../context/ThemeContext";
import Singlecompany from "../somadome/singleCompany";
import Dashboardview from "../somadome/Dashboard_view";
import Hubspot from "../somadome/Somahome";
import JobLists from "../somadome/JobLists";
import AllTickets from "./pages/tickets/AllTickets";
import AllAnnouncements from "./pages/announcements/AllAnnouncements";
import CreateAnnouncements from "./pages/announcements/CreateAnnouncements";
import EditAnnouncements from "./pages/announcements/EditAnnouncements";
import Hosts from "../pages/hosts/AllHosts";
import HostDetails from "../pages/hosts/HostDetails";
import CreateHost from "../pages/hosts/CreateHosts";
import CreateDome from "../pages/dome/CreateDome";
import HostDomes from "../pages/dome/HostDomes";
import DomeDetails from "../pages/dome/DomeDetails";
import EditDome from "../pages/dome/EditDome";
import EditHost from "../pages/hosts/EditHosts";
import CreateSession from "../pages/sessions/CreateSession";
import DomeSessions from "../pages/sessions/ViewSessions";
import DomeBookings from "../pages/bookings/ViewBookings";

const Markup = () => {
  const allroutes = [
    //own
    { url: "company-list", component: <Hubspot /> },
    { url: "hosts", component: <Hosts /> },
    { url: "hosts/create", component: <CreateHost /> },
    { url: "hosts/:id", component: <HostDetails /> },
    { url: "hosts/:id/edit", component: <EditHost /> },
    { url: "hosts/:id/dome", component: <HostDomes /> },
    { url: "hosts/:id/dome/create", component: <CreateDome /> },
    { url: "hosts/:id/dome/:domeid", component: <DomeDetails /> },
    { url: "hosts/:id/dome/:domeid/edit", component: <EditDome /> },
    { url: "hosts/:id/dome/:domeid/sessions/create", component: <CreateSession /> },
    { url: "hosts/:id/dome/:domeid/sessions", component: <DomeSessions /> },
    { url: "hosts/:id/dome/:domeid/bookings", component: <DomeBookings /> },
    { url: "admin", component: <Hubspot /> },
    { url: "dashboard", component: <JobLists /> },
    { url: "tickets", component: <AllTickets /> },
    { url: "announcements", component: <AllAnnouncements /> },
    { url: "announcements/create", component: <CreateAnnouncements /> },
    { url: "announcements/edit/:id", component: <EditAnnouncements /> },
    { url: "dashboard/:id", component: <Singlecompany /> },
    { url: "dashboard/table", component: <Dashboardview /> },
  ];

  return (
    <>
      <Routes>
        <Route path="page-lock-screen" element={<LockScreen />} />
        <Route path="page-error-400" element={<Error400 />} />
        <Route path="page-error-403" element={<Error403 />} />
        <Route path="page-error-404" element={<Error404 />} />
        <Route path="page-error-500" element={<Error500 />} />
        <Route path="page-error-503" element={<Error503 />} />
        <Route element={<MainLayout />}>
          {allroutes.map((data, i) => (
            <Route
              key={i}
              exact
              path={`${data.url}`}
              element={data.component}
            />
          ))}
        </Route>
      </Routes>
      <ScrollToTop />
    </>
  );
};

function MainLayout() {
  const { menuToggle, sidebariconHover } = useContext(ThemeContext);
  return (
    <>
      <div
        id="main-wrapper"
        className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${
          menuToggle ? "menu-toggle" : ""
        }`}
      >
        <Nav />
        <div
          className="content-body"
          style={{ minHeight: window.screen.height - 45 }}
        >
          <div className="container-fluid">
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
      <Setting />
    </>
  );
}

export default Markup;
